// src/components/StatItem.tsx
import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { CountingNumber } from "./NumbersSection"; // Importando CountingNumber de NumbersSection

interface StatItemProps {
  stat: {
    value: number;
    label: string;
    prefix?: string;
    suffix?: string;
  };
  index: number; // Para o delay da transição
}

const StatItem = ({ stat, index }: StatItemProps) => {
  const statRef = useRef<HTMLDivElement>(null);
  const isStatInView = useInView(statRef, { once: true, amount: 0.5 }); // Detecta quando o stat individual entra na view

  return (
    <motion.div
      ref={statRef} // Anexa o ref individual aqui
      key={stat.label} // Key deve estar no elemento que é mapeado, não aqui. Mas por segurança, mantenho
      initial={{ opacity: 0, y: 40 }}
      animate={isStatInView ? { opacity: 1, y: 0 } : {}} // Anima o container do stat
      transition={{ duration: 0.6, delay: 0.1 * index }}
      className="text-center relative"
    >
      <div className="relative inline-block">
        <span className="font-heading text-5xl sm:text-6xl lg:text-7xl font-semibold text-primary">
          <CountingNumber value={stat.value} prefix={stat.prefix} suffix={stat.suffix} animateOnView={isStatInView} />
        </span>
        {/* Subtle accent line */}
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-12 h-0.5 bg-accent/30" />
      </div>
      <p className="mt-4 text-sm text-muted-foreground uppercase tracking-wider">
        {stat.label}
      </p>
    </motion.div>
  );
};

export default StatItem;
